module.exports = __webpack_public_path__ + "img/pr-4.33376c41.png";